import React, { Fragment, memo, useEffect } from 'react'
import PropTypes from 'prop-types'
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';

import { useDispatch, useSelector } from 'react-redux'

import { useModal } from '../../../utils/hooks'
import { Button, FormGroup, FormLabel, Modal, RadioGroup, Radio } from '../../../components'
import { globalSettingsActions, selectGlobalSettings } from '../../../utils/slices/settings.slice'
import {
  GLOBAL_SETTINGS_FONTSIZE_OPTIONS,
  GLOBAL_SETTINGS_ORIENTATION_OPTIONS,
} from '../../../utils/constants'
import { setAppFontSize } from '../../../utils/fns'

const GlobalSettings = ({ fontSizeOptions, orientationOptions, children }) => {
  const dispatch = useDispatch()
  const { fontSize, orientation } = useSelector(selectGlobalSettings)
  const [show, onHide] = useModal(false)

  useEffect(() => {
    setAppFontSize(fontSize)
    document.documentElement.classList.add('-themeLight')
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target

    dispatch(globalSettingsActions.updateGlobalSettings({ [name]: value }))

    if (name === 'fontSize') {
      setAppFontSize(value)
    }
  }

  return (
    <Fragment>
      <Button variant="topNav" className="button topNav__button -settings" onClick={onHide}>
        <SettingsTwoToneIcon className='material-icons-two-tone' />
        <span className="button__text">Settings</span>
      </Button>
      <Modal
        className="settings"
        show={show}
        onHide={onHide}
        header={
          <Modal.Header closeButton>
            <h3>Settings</h3>
          </Modal.Header>
        }
      >
        <FormGroup>
          <FormLabel htmlFor="fontSize">Display Density</FormLabel>
          <RadioGroup name="fontSize" selectedValue={fontSize} onChange={handleChange}>
            {fontSizeOptions.map((opt) => (
              <label className="inputLabel" key={opt.label}>
                <Radio value={opt.value} />
                <span>{opt.label}</span>
              </label>
            ))}
          </RadioGroup>
        </FormGroup>

        <FormGroup>
          <FormLabel htmlFor="orientation">Pane Orientation</FormLabel>
          <RadioGroup name="orientation" selectedValue={orientation} onChange={handleChange}>
            {orientationOptions.map((opt) => (
              <label className="inputLabel" key={opt.label}>
                <Radio value={opt.value} />
                <span>{opt.label}</span>
              </label>
            ))}
          </RadioGroup>
        </FormGroup>
        {children}
      </Modal>
    </Fragment>
  )
}

GlobalSettings.propTypes = {
  fontSizeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  orientationOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.element]),
}

GlobalSettings.defaultProps = {
  fontSizeOptions: GLOBAL_SETTINGS_FONTSIZE_OPTIONS,
  orientationOptions: GLOBAL_SETTINGS_ORIENTATION_OPTIONS,
}

export default memo(GlobalSettings)
